/**
 * @generated SignedSource<<25666cad21b97ee6ad8ab0565b8b2362>>
 * @relayHash dfc3f85ef6a5285011e0e7dee40b0a02
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7f7034bf9f494dd100ebdebb90140019edef40ed0b73b4f99438b18d3ef66bee

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HomeStarredListQuery$variables = {
  cypherQuery: string;
  first?: number | null;
  queryContext: string;
};
export type HomeStarredListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HomeStarredList">;
};
export type HomeStarredListQuery = {
  response: HomeStarredListQuery$data;
  variables: HomeStarredListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cypherQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v3 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v4 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "value"
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "title"
},
v10 = [
  {
    "kind": "ScalarField",
    "name": "webUi"
  },
  {
    "kind": "ScalarField",
    "name": "base"
  }
],
v11 = [
  {
    "concreteType": "ConfluenceFavoritedSummary",
    "kind": "LinkedField",
    "name": "favoritedSummary",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "favoritedAt"
      },
      {
        "kind": "ScalarField",
        "name": "isFavorite"
      },
      (v5/*: any*/)
    ]
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "concreteType": "ConfluenceSpace",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    {
      "concreteType": "ConfluenceSpaceLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v10/*: any*/)
    },
    (v8/*: any*/)
  ]
},
v14 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v15 = {
  "concreteType": "ConfluenceContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ConfluenceContentTitleEmoji",
      "kind": "LinkedField",
      "name": "titleEmojiPublished",
      "plural": false,
      "selections": (v7/*: any*/)
    }
  ]
},
v16 = {
  "concreteType": "ConfluenceContentViewerSummary",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v11/*: any*/)
},
v17 = {
  "concreteType": "ConfluenceContentVersion",
  "kind": "LinkedField",
  "name": "latestVersion",
  "plural": false,
  "selections": [
    (v14/*: any*/)
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "url"
},
v19 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v12/*: any*/),
    {
      "kind": "ScalarField",
      "name": "accountStatus"
    },
    (v8/*: any*/)
  ]
},
v20 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isStarred_extension"
    }
  ]
},
v21 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v22 = [
  {
    "kind": "ScalarField",
    "name": "creationDate"
  },
  {
    "kind": "ScalarField",
    "name": "editDate"
  },
  (v8/*: any*/)
],
v23 = {
  "kind": "ScalarField",
  "name": "iconData"
},
v24 = [
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HomeStarredListQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cypherQuery",
            "variableName": "cypherQuery"
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "HomeStarredList"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "HomeStarredListQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": [
              (v3/*: any*/),
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "cypherQuery"
              },
              (v4/*: any*/)
            ],
            "concreteType": "GraphStoreCypherQueryV2Connection",
            "kind": "LinkedField",
            "name": "cypherQueryV2",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreCypherQueryV2Edge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "GraphStoreCypherQueryV2Node",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GraphStoreCypherQueryV2Column",
                        "kind": "LinkedField",
                        "name": "columns",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v7/*: any*/),
                                "type": "GraphStoreCypherQueryV2TimestampObject"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v8/*: any*/),
                                          (v9/*: any*/),
                                          {
                                            "concreteType": "ConfluenceBlogPostLinks",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": (v10/*: any*/)
                                          },
                                          {
                                            "concreteType": "ConfluenceBlogPostViewerSummary",
                                            "kind": "LinkedField",
                                            "name": "viewer",
                                            "plural": false,
                                            "selections": (v11/*: any*/)
                                          },
                                          (v13/*: any*/),
                                          (v14/*: any*/),
                                          (v15/*: any*/)
                                        ],
                                        "type": "ConfluenceBlogPost"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v8/*: any*/),
                                          (v9/*: any*/),
                                          {
                                            "concreteType": "ConfluenceDatabaseLinks",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": (v10/*: any*/)
                                          },
                                          (v16/*: any*/),
                                          (v17/*: any*/),
                                          (v13/*: any*/)
                                        ],
                                        "type": "ConfluenceDatabase"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v8/*: any*/),
                                          (v9/*: any*/),
                                          {
                                            "concreteType": "ConfluencePageLinks",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": (v10/*: any*/)
                                          },
                                          {
                                            "concreteType": "ConfluencePageViewerSummary",
                                            "kind": "LinkedField",
                                            "name": "viewer",
                                            "plural": false,
                                            "selections": (v11/*: any*/)
                                          },
                                          (v13/*: any*/),
                                          (v14/*: any*/),
                                          (v15/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "subtype"
                                          }
                                        ],
                                        "type": "ConfluencePage"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v8/*: any*/),
                                          (v9/*: any*/),
                                          {
                                            "concreteType": "ConfluenceWhiteboardLinks",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": (v10/*: any*/)
                                          },
                                          (v16/*: any*/),
                                          (v17/*: any*/),
                                          (v13/*: any*/)
                                        ],
                                        "type": "ConfluenceWhiteboard"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v8/*: any*/),
                                          (v12/*: any*/),
                                          (v18/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "starred"
                                          },
                                          {
                                            "concreteType": "MercuryFocusArea",
                                            "kind": "LinkedField",
                                            "name": "parent",
                                            "plural": false,
                                            "selections": [
                                              (v8/*: any*/),
                                              (v12/*: any*/),
                                              (v18/*: any*/)
                                            ]
                                          },
                                          {
                                            "alias": "focusAreaIcon",
                                            "concreteType": "MercuryFocusAreaIcon",
                                            "kind": "LinkedField",
                                            "name": "icon",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/)
                                            ]
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "createdDate"
                                          },
                                          (v19/*: any*/)
                                        ],
                                        "type": "MercuryFocusArea"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v8/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "displayName"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "profileUrl"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "largeAvatarImageUrl"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "state"
                                          },
                                          {
                                            "concreteType": "TeamType",
                                            "kind": "LinkedField",
                                            "name": "type",
                                            "plural": false,
                                            "selections": [
                                              (v12/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "verified"
                                              },
                                              (v8/*: any*/)
                                            ]
                                          },
                                          (v20/*: any*/)
                                        ],
                                        "type": "TeamV2"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v8/*: any*/),
                                          (v12/*: any*/),
                                          (v18/*: any*/),
                                          {
                                            "alias": "goalState",
                                            "concreteType": "TownsquareGoalState",
                                            "kind": "LinkedField",
                                            "name": "state",
                                            "plural": false,
                                            "selections": (v7/*: any*/)
                                          },
                                          {
                                            "alias": "goalCreationDate",
                                            "kind": "ScalarField",
                                            "name": "creationDate"
                                          },
                                          {
                                            "alias": "goalUpdates",
                                            "args": (v21/*: any*/),
                                            "concreteType": "TownsquareGoalUpdateConnection",
                                            "kind": "LinkedField",
                                            "name": "updates",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareGoalUpdateEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareGoalUpdate",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v22/*: any*/)
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "updates(first:1)"
                                          },
                                          {
                                            "alias": "goalStatus",
                                            "concreteType": "TownsquareStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                              (v6/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "score"
                                              }
                                            ]
                                          },
                                          (v23/*: any*/),
                                          (v19/*: any*/),
                                          (v20/*: any*/)
                                        ],
                                        "type": "TownsquareGoal"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v8/*: any*/),
                                          (v12/*: any*/),
                                          (v18/*: any*/),
                                          {
                                            "alias": "projectState",
                                            "concreteType": "TownsquareProjectState",
                                            "kind": "LinkedField",
                                            "name": "state",
                                            "plural": false,
                                            "selections": (v7/*: any*/)
                                          },
                                          {
                                            "alias": "projectCreationDate",
                                            "kind": "ScalarField",
                                            "name": "creationDate"
                                          },
                                          {
                                            "alias": "projectUpdates",
                                            "args": (v21/*: any*/),
                                            "concreteType": "TownsquareProjectUpdateConnection",
                                            "kind": "LinkedField",
                                            "name": "updates",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareProjectUpdateEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareProjectUpdate",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v22/*: any*/)
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "updates(first:1)"
                                          },
                                          (v23/*: any*/),
                                          (v19/*: any*/),
                                          (v20/*: any*/)
                                        ],
                                        "type": "TownsquareProject"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "AppUser"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "AtlassianAccountUser"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "CustomerUser"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "DevOpsFeatureFlag"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "DevOpsOperationsComponentDetails"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "DevOpsOperationsIncidentDetails"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "DevOpsOperationsPostIncidentReviewDetails"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "DevOpsProjectDetails"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "DevOpsPullRequestDetails"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "DevOpsRepository"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "DevOpsSecurityVulnerabilityDetails"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "JiraAutodevJob"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "JiraConfluenceRemoteIssueLink"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "JiraCustomRemoteIssueLink"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "JiraIssueRemoteIssueLink"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "JiraWebRemoteIssueLink"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "TeamCustomFieldValue"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "TeamType"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v24/*: any*/),
                                        "type": "ThirdPartyUser"
                                      }
                                    ]
                                  },
                                  (v8/*: any*/)
                                ],
                                "type": "GraphStoreCypherQueryV2AriNode"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7f7034bf9f494dd100ebdebb90140019edef40ed0b73b4f99438b18d3ef66bee",
    "metadata": {},
    "name": "HomeStarredListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3d74b3dd2613ded51e98e127dec5f3b6";

export default node;
